import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useState } from 'react'

import ConfirmModal from 'components/ConfirmModal'
import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.picker.canonical')

type Props = {
  disabled: boolean
  onSwitchToSmart: () => void
}

/**
 * One grey line under a fixed list, with the way back to smart grouping; the
 * mode pill already names the mode. Going back discards the picks, so it asks first.
 */
const ManualListNotice = ({ disabled, onSwitchToSmart }: Props) => {
  const [isConfirming, setIsConfirming] = useState(false)

  // The picker may have been submitted while the modal was open
  const switchToSmart = () => {
    setIsConfirming(false)
    if (!disabled) onSwitchToSmart()
  }

  return (
    <div>
      <div className="d-flex align-items-center flex-wrap mt-xs">
        <Text.BodyText5 color="grey70" className="mr-xs">
          {t('manual_notice.body')}
        </Text.BodyText5>
        <Button
          kind="minimal"
          size="small"
          className="p-0"
          disabled={disabled}
          onClick={() => setIsConfirming(true)}
        >
          {t('manual_notice.action')}
        </Button>
      </div>
      <ConfirmModal
        isOpen={isConfirming}
        title={t('switch_to_smart.title')}
        description={t('switch_to_smart.description')}
        confirmText={t('switch_to_smart.confirm')}
        cancelText={t('switch_to_smart.cancel')}
        onClose={() => setIsConfirming(false)}
        onConfirm={switchToSmart}
      />
    </div>
  )
}

export default ManualListNotice
